import { createRoutine } from 'redux-saga-routines';

export const showDeleteHoldingModal = createRoutine('@HOLDING_DELETE/SHOW');
export const hideDeleteHoldingModal = createRoutine('@HOLDING_DELETE/HIDE');
